export const PetWeight = {
  Small: 5,
  Medium: 21,
  Large: 51,
  XL: 100,
};

export const petWeightOptions = [{
  label: 'S: 5 - 20 lb',
  value: String(PetWeight.Small),
}, {
  label: 'M: 21 - 50 lb',
  value: String(PetWeight.Medium),
}, {
  label: 'L: 51 - 99 lb',
  value: String(PetWeight.Large),
}, {
  label: 'XL: 100+ lb',
  value: String(PetWeight.XL),
}];
